<div class="age-range" [matTooltip]="tooltip">
  <span class="age-range__badge">
    <svg
      class="age-range__dot"
      [class]="color"
      viewBox="0 0 6 6"
      aria-hidden="true"
    >
      <circle cx="3" cy="3" r="3" />
    </svg>
    {{ name }}
  </span>
</div>
